// Please keep keys lowercase!
exports.supportedLanguages = {
    en: 'English',
    ru: 'Русский',
};
